module.exports = __webpack_public_path__ + "static/NEOGOV-Logo-RGB-5a4d6037b0017736e6ab67d5a93d49fb.png";